<template>
  <v-card class="rounded-lg mt-1" light height="86">
    <v-card class="position-absolute pos-left pos-top rounded-lg" :color="$vuetify.theme.currentTheme.accent" height="100%" width="20"></v-card>
    <v-card-title class="pt-1 pb-0">
      <v-avatar size="20" :color="$vuetify.theme.currentTheme.accent" class="mt-0 pt-0 ml-n4" >
        <v-icon
          size="15"
          color="white"
        >
          mdi-web
        </v-icon>
      </v-avatar>
    </v-card-title>
    <v-card-text class="pb-0 mt-n6 px-8">
      <v-row>
        <v-col md="12" class="my-0 pt-3 pb-0">
          {{extraccion.texto.length>max_length_text ? extraccion.texto.slice(0,max_length_text)+'...' : extraccion.texto}}
        </v-col>
        <v-col md="8" class="py-0">
          <small><b>Url:</b> {{extraccion.data_id}}</small>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="py-0 mt-n5">
      <v-row>
        <v-col md="2" offset="10" class="py-0 text-right pt-0">
          <v-btn
            color="info"
            text
            large
            @click="mostrar_texto = true"
          >
            <strong>...</strong>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-dialog
      v-model="mostrar_texto"
      max-width="800"
    >
      <v-card light>
        <v-card-title>
          {{extraccion.data_id}}
        </v-card-title>
        <v-card-text>
          <json-view
            :data="extraccion"
            rootKey="Detalles"
            :styles="{ arrowSize: '1px' }"
            class="customize"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="mostrar_texto = false"
          >
            cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {JSONView} from "vue-json-component";

export default {
  props:{
    extraccion:{
      type: Object,
      required:true
    }
  },
  components: { "json-view": JSONView },
  data(){
    return{
      mostrar_texto:false,
      max_length_text:300
    }
  }
}
</script>

<style>
</style>
